/**
 * Elfelejtett jelszó feature szövegei
 *
 * Namespace: forgotPassword
 */
export const forgotPassword = {
  // Oldal
  page: {
    title: "Elfelejtett jelszó",
    subtitle: "Add meg az email címed a jelszó visszaállításához",
    backToLogin: "Vissza a bejelentkezéshez",
  },

  // Űrlap mezők
  form: {
    emailLabel: "Email cím",
    emailPlaceholder: "te@example.com",
    submitButton: "Küldés",
    loadingButton: "Küldés...",
  },

  // Hibák
  errors: {
    recaptchaFailed: "reCAPTCHA ellenőrzés sikertelen. Kérjük, próbáld újra.",
  },

  // Sikeres küldés
  success: {
    title: "Email elküldve!",
    message:
      "Ha az email cím szerepel a rendszerünkben, hamarosan kapsz egy levelet a jelszó visszaállításához.",
    backToLogin: "Vissza a bejelentkezéshez",
  },
} as const;

export type ForgotPasswordMessages = typeof forgotPassword;
